import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { SettlementView } from '../utils';
import { t, type Language } from '../../../i18n/translations';

export function renderAssistantsTab(
    builder: ContentBuilder,
    settlement: SettlementView,
    lang: Language,
): void {
    builder.section(t(lang, 'tabs.assistants.title'), (section: ContentBuilder): void => {
        for (let i = 0; i < settlement.assistantLogistics.slots.length; i++) {
            const slot = settlement.assistantLogistics.slots[i];
            if (slot.status === 'idle') {
                section.progress('Agent ' + i, 0, 1);
                section.wrappedText('Idle', 'body', 2);
            } else {
                section.progress('Agent ' + i, slot.ticksLeft, slot.initialTicks);
                let text = '';

                switch (slot.phase) {
                    case 'toPickup':
                    case 'toDropoff':
                    case 'toDeliver':
                    case 'returnEmpty':
                        text += slot.phase;
                }

                text += ' ' + slot.task.kind;

                switch (slot.task.kind) {
                    case 'deliverHouse':
                    case 'deliverBuildingInput':
                        text += ' ' + slot.task.kind;
                        switch (slot.task.payload.kind) {
                            case 'tool':
                                text +=
                                    ' a tool with durability ' + slot.task.payload.tool.durability;
                                break;
                            case 'weapons':
                                text += ` ${slot.task.payload.amount} weapons`;
                                break;
                            case 'numeric':
                                text += ` ${slot.task.payload.resource} ${slot.task.payload.amount}`;
                                break;
                        }
                        break;
                    case 'pickupBuildingOutput':
                    case 'transferBuildingToBuilding':
                        text += ' ' + slot.task.kind + ' ' + slot.task.resource;
                        break;
                }

                section.wrappedText(text, 'body', 2);
            }
        }
    });
}
